import { api } from '../../api'
import { ApiParams, VehiclesResponse } from '../../types'

const getVehicles = async ({ filters }: ApiParams) => {
  const response = await api.get<VehiclesResponse>('/trucks', {
    params: filters,
  })

  return response.data.trucks
}

const VehiclesApi = { getVehicles }

export default VehiclesApi
